import React from 'react'
import './Reason.css'
import image1 from '../../assets/image1.png'
import image2 from '../../assets/image2.png'
import image3 from '../../assets/image3.png'
import image4 from '../../assets/image4.png'
import tick from '../../assets/tick.png'
import nb from '../../assets/nb.png'
import adidas from '../../assets/adidas.png'
import nike from '../../assets/nike.png'
const Reasons = () => {
    return (
        <div className="Reasons" id="reasons">
            <div className="left">
                <img src={image1} alt="" />
                <img src={image2} alt="" />
                <img src={image3} alt="" />
                <img src={image4} alt="" />
            </div>
            <div className="right">
                <span style={{ textTransform: 'uppercase', fontSize: '2rem' }}>some reasons</span>
                <div><span className='stroke-text'>why</span>
                    <span> choose us</span></div>
                <div className='details'>
                    <div><img src={tick} alt="">
                    </img><span>ione f3v4f</span></div>
                    <div><img src={tick} alt="" /><span>vfvi34ufv
                    </span></div>
                    <div><img src={tick} alt="" /><span> li3fy3vf
                    </span></div>
                    <div><img src={tick} alt="" /><span>4vfiupv4
                    </span></div>
                    <span style={{
                        color: 'var(--gray)',
                        fontWeight: 'normal',
                        fontSize: '1.5rem',
                    }}>our partners</span>
                    <div className="partners">
                        <img src={nb} alt="" />
                        <img src={adidas} alt="" />
                        <img src={nike} alt="" />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Reasons
